import clsx from "clsx";
import type { PropsWithChildren } from "react";
import React from "react";
import { tw } from "./tailwind";
import { Text } from "./text";
import type { Style } from "./types";

/** Props Interface */
interface HeadingProps extends PropsWithChildren {
	style?: Style;
	fixed?: boolean;
}

export function Heading({ children, style = {}, fixed }: HeadingProps) {
	return (
		<React.Fragment>
			<Text
				fixed={fixed}
				style={{
					...tw(clsx("text-sm font-bold")),
					...(style as object),
				}}
			>
				{children}
			</Text>
		</React.Fragment>
	);
}
